import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  InventoryPage,
  inventoryLevelsQueryOptions,
  inventoryListParams,
  inventoryListSearchSchema,
  stockLocationsQueryOptions,
} from '@/features/inventory';

export const Route = createFileRoute('/_authed/_active/s/$storeId/inventory')({
  staticData: { crumb: 'common:nav.inventory', tours: ['inventory.levels'] },
  validateSearch: inventoryListSearchSchema,
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'inventory.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = Promise.all([
      context.queryClient.query({
        ...stockLocationsQueryOptions(params.storeId),
        staleTime: 'static',
      }),
      context.queryClient.query({
        ...inventoryLevelsQueryOptions(params.storeId, inventoryListParams(deps)),
        staleTime: 'static',
      }),
    ]).catch(() => undefined);
    // Filter, sort and page changes on the list itself must not wait for the fetch, or a second
    // pick in the filter builds on the stale URL; the page shows the previous rows meanwhile.
    if (cause !== 'stay') await prefetch;
  },
  component: InventoryPage,
});
